import styled from 'styled-components';
import { Layout } from 'antd';

const { Header } = Layout;

export const HeaderContainer = styled(Header)`
  &.ant-layout-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 8px;
    line-height: 1.5715;

    background-color: #FFCC00;
    border-bottom: 1px solid ${props => props.theme.palette.border};
  }
`;
